import { AndroidBanner } from '../AndroidBanner';
import { DesktopBanner } from '../DesktopBanner';
import { IOSBanner } from '../IOSBanner';

import { useBanner } from './hooks/useBanner';

type Props = {
	sourceLocation: string;
	iOSBannerEnabled: boolean;
	androidBannerEnabled: boolean;
	desktopBannerEnabled: boolean;
	bottomOffsetPx?: number;
};

export const Banner = ({
	sourceLocation,
	iOSBannerEnabled,
	androidBannerEnabled,
	desktopBannerEnabled,
	bottomOffsetPx,
}: Props): React.JSX.Element | null => {
	const {
		data: { isIPhoneUserAgent, isAndroidPhoneUserAgent, isMobileUserAgent, bannerClosed },
		actions: { setBannerClosed },
	} = useBanner();

	if (bannerClosed) return null;

	return (
		<>
			{iOSBannerEnabled && isIPhoneUserAgent && (
				<IOSBanner sourceLocation={sourceLocation} setBannerClosed={setBannerClosed} bottomOffsetPx={bottomOffsetPx} />
			)}
			{androidBannerEnabled && isAndroidPhoneUserAgent && (
				<AndroidBanner
					sourceLocation={sourceLocation}
					setBannerClosed={setBannerClosed}
					bottomOffsetPx={bottomOffsetPx}
				/>
			)}
			{desktopBannerEnabled && !isMobileUserAgent && (
				<DesktopBanner sourceLocation={sourceLocation} setBannerClosed={setBannerClosed} />
			)}
		</>
	);
};
